<form [formGroup]="form" class="gp-generated-form">
  <div #row>
    <div class="scrollable-tabs-container">
      <button class="scroll-button scroll-left"
              (click)="scrollTabs('left')"
              *ngIf="isScrollingEnabled"
      [disabled]="!canScrollLeft || scrolling"
      [class.disabled]="!canScrollLeft || scrolling">
      <i class="fa fa-lg fa-solid fa-caret-left" aria-hidden="true"></i>
      </button>
      <ul class="nav nav-tabs full-width" #tabsContainer>
        <li class="nav-item inline tab-with-dropdown" *ngFor="let tab of tabs"
            [style.display]="hiddenTabIds.includes(tab.instance.descriptor.tabSheetID) ? 'none' : null">
          <a class="nav-link block"
             [attr.test-id]="tab.instance.descriptor.transId"
             [ngClass]="{
                 'active': tab.instance.active
               }"
             (click)="activateTab(tab.instance)">
            <em *ngIf="errorMap.get(tab.instance.descriptor?.tabSheetID)"
                class="fa fa-solid"
                [class.fa-exclamation-triangle]="!isSkillModule"
                [class.tab-has-errors]="!isSkillModule"></em>
            {{ tab.instance.descriptor.transId | translate }}
            <em class="fa fa-light fa-chevron-down tab-chevron"
                data-tour="tab-groupzone-selector"
                *ngIf="getUniqueGroupZoneCount(tab.instance.descriptor.groupZones) > 1"
                (click)="toggleTabDropdown($event, tab.instance.descriptor.tabSheetID)"></em>
          </a>
        </li>
      </ul>
      <button class="scroll-button scroll-right"
              (click)="scrollTabs('right')"
              *ngIf="isScrollingEnabled"
              [disabled]="!canScrollRight || scrolling"
              [class.disabled]="!canScrollRight || scrolling">
        <i class="fa fa-lg fa-solid fa-caret-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="tab-content">
      <ng-content select=".gp-tab-pane-header"></ng-content>
      <div class="p-a-lg text-center" *ngIf="loading">
        <i class="fa fa-light fa-spinner fa-spin"></i>
      </div>
      <div #tabPanes></div>
    </div>
  </div>
  <div class="back-top-button" back-to-top [element]="row">
    <i class="fa fa-light fa-arrow-up"></i>
  </div>

  <ng-container *ngIf="openDropdownTabId">
    <div class="tab-dropdown-backdrop" (click)="closeDropdown()"></div>
    <ul class="tab-dropdown"
        [style.top.px]="dropdownPosition.top"
        [style.left.px]="dropdownPosition.left">
      <ng-container *ngFor="let tab of tabs">
        <ng-container *ngIf="tab.instance.descriptor.tabSheetID === openDropdownTabId">
          <li *ngFor="let gz of getUniqueGroupZones(tab.instance.descriptor.groupZones)"
              class="tab-dropdown__item"
              (click)="scrollToGroupZone($event, tab.instance, gz.groupZoneID)">
            <span class="tab-dropdown__label">{{ gz.transId | translate }}</span>
            <em *ngIf="!isSkillModule && isGroupZoneInError(tab.instance.descriptor.tabSheetID, gz.groupZoneID)"
                class="fa fa-solid fa-exclamation-circle groupzone-has-errors"
                aria-hidden="true"></em>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </ng-container>
</form>
